/*
    This file is part of Universal Sequencer.
    Universal Sequencer is free software: you can redistribute it and/or modif
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Universal Sequences is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import React, { Component } from 'react';
import BasicWaveform from 'components/waveform/BasicWaveform.js';
import { withRouter } from 'react-router';
import Tone from 'tone';
import {crop} from 'engine/Crop.js';
import axios from 'axios';
import YoutubeInfo from 'components/Youtube.js';
import { Card, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import {NOT_UPLOADED_YET} from 'constants/ipfs-constants.js';
import AudioUnit from 'engine/audio.js';
import {exportToWAV} from 'api/exportToWav.js';
import ipfs from 'decentralized/Ipfs.js';

// Detailed View for a track
class SoundDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cropping: undefined,
        };
        this.state.name = props.name;
        this.state.videoId = props.videoId;
        this.state.soundId = props.soundId;
        this.state.waveforms = 1;
        this.state.start = 0;
        this.sampler = props.sampler;
    }

    crop(start, end) {
        let sampleRate = Tone.Master.context.sampleRate;
        let cropped = crop(
            this.props.sampler.baseBuffer.get(),
            start * sampleRate, end * sampleRate, Tone.Master.context);
        let oldId = this.props.sampler.sample.ipfsHash;
        exportToWAV(
            [cropped.getChannelData(0),
             cropped.getChannelData(1)],
            sampleRate)
            .then(buffer =>
                  ipfs.addBytesArray(buffer))
            .then(id => {
                let i = this.props.track.soundIds.indexOf(oldId);
                this.props.track.soundIds[i] = id;
                delete this.props.track.samplers[oldId];
                this.props.track.samplers[id] = this.props.sampler;
                this.props.sampler.sample.ipfsHash = id;
            });
        this.props.sampler.replaceBuffer(cropped);
        if (this.state.cropping) {
            this.setState({
                cropping: this.state.cropping + 1
            });
        } else {
            this.setState({
                cropping: 1
            });
        }
    }

    cropSlices() {
        let samples = this.props.sampler.slices.map(x => x.buffer._buffer)
            .map(x => {
                let sample = this.props.sampler.sample.getCopy();
                sample.ipfsHash = NOT_UPLOADED_YET;
                sample.needsSave = true;
                sample.audioBuffer = x;
                return sample;
            });

        for (let sample of samples) {
            this.props.track.sequencerEngine.addSound(sample);
        }
    }

    render() {
        let buffer = this.props.sampler.baseBuffer.get();
        let sample = this.props.track.isFrozen ?
            this.props.track.frozenColumns[0].frozenSamples[0] :
            this.props.track.sample;
        return (
            <BasicWaveform
              sample={sample}
              cropSlices={() => this.cropSlices()}
              id={this.props.id}
              track={this.props.track}
              crop={(s, e) => this.crop(s,e)}
              fullWidth={true}
              selectedSlice={this.props.selectedSlice}
              slices={this.props.sampler.slices}
              height={this.props.height || this.props.bottomHeight - 140}
              small={this.props.small}
              isReversed={this.props.sampler.isReversed()}
              sampler={this.props.sampler}
              div={this.props.div}
              decentralized={this.props.decentralized}
              soundId={this.state.cropping ? this.state.cropping : sample.getId()}
              onKeyDown={this.props.onKeyDown}
              onSelectSlice={this.props.onSelectSlice}
              width={this.props.width}
              onChangeReversed={this.props.onChangeReversed}
              xBounds={0}
              buffer={buffer}>
              {this.props.children}
            </BasicWaveform>
        );
    }
}

export default SoundDetail;
